"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Dropdown = _interopRequireDefault(require("../Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_Dropdown["default"]); // eslint-disable-line

/**
 * React component which allows selection of a single item from a dropdown list
 * Substitute for the native select element.
 */


var ItemHeader = function ItemHeader(props) {
  var children = props.children,
      attrs = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/_react["default"].createElement("li", _extends({
    className: cx('dropdown__list-item-header')
  }, attrs), children);
};

ItemHeader.displayName = 'ItemHeader';
ItemHeader.propTypes = {
  /** HTML Node that will appear in the component */
  children: _propTypes["default"].node
};
ItemHeader.defaultProps = {
  children: null
};
var _default = ItemHeader;
exports["default"] = _default;